import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ConfigSwitch from "../../../../../../components/common/BriaSwitch/Config/ConfigSwitch";
import { useAppStore } from "../../../../../../hooks/useStores";
import { isLightVersion, isMaxVersion } from "../../../../utils/tg-utils";

type TgFastSwitchProps = {
	hide?: boolean;
};

const TgFastSwitch = ({ hide }: TgFastSwitchProps) => {
	const { t } = useTranslation("tg", { keyPrefix: "app.image.config.fast" });
	const { textToImageStore, tgStore } = useAppStore();
	const { tgModelPlaygroundStore } = tgStore;
	const { handleConfigChange } = textToImageStore;
	const [localFast, setLocalFast] = useState<boolean | undefined>(undefined);

	const models = [textToImageStore.config, ...tgModelPlaygroundStore.compareModels];
	const isAnyMaxVersion = models.some((m) => isMaxVersion(m?.training_version));
	const isAnyLightVersion = models.some((m) => isLightVersion(m?.training_version));

	const isRestylePortrait = !!textToImageStore.config.restyle_portrait;
	const isDisabled = isAnyMaxVersion || isRestylePortrait;

	useEffect(() => {
		const fastValue = isAnyMaxVersion ? false : isRestylePortrait ? true : (localFast ?? isAnyLightVersion);
		handleConfigChange("fast", fastValue);
	}, [isAnyMaxVersion, isRestylePortrait, isAnyLightVersion]);

	const handleFastModeChange = (checked: boolean) => {
		handleConfigChange("fast", checked);
		setLocalFast(checked);
	};

	const getInfo = () => {
		if (isAnyMaxVersion) return t("disabledInfoMax");
		if (isRestylePortrait) return t("disabledInfoRestylePortrait");
		return t("info");
	};

	return (
		<>
			{hide ? null : (
				<ConfigSwitch
					label={t("label")}
					info={getInfo()}
					checked={!!textToImageStore.config.fast}
					onChange={handleFastModeChange}
					disabled={isDisabled}
				/>
			)}
		</>
	);
};

export default observer(TgFastSwitch);
